import { render, staticRenderFns } from "./SettingPlanAddQ.vue?vue&type=template&id=37638369&scoped=true&"
import script from "./SettingPlanAddQ.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAddQ.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAddQ.vue?vue&type=style&index=0&id=37638369&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37638369",
  null
  
)

export default component.exports